import React from 'react'
import styles from './PageTitle.module.scss'

interface Props {
    title: string
    children?: React.ReactNode
}

const PageTitle = ({ title, children }: Props) => (
    <>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{children}</p>
    </>
)

export default PageTitle
